<template>
    <v-overlay v-show="show" color="black">
        <v-row>
            <v-col cols="auto" class="text-h4">정산정책 관리</v-col>
            <v-spacer />
            <v-col cols="auto">
                <v-icon x-large @click="close">mdi-close</v-icon>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <overlay-setting-commission v-model="show" @close="close" />
            </v-col>
            <v-col>
                <overlay-setting-holiday v-model="show" @close="close" />
            </v-col>
        </v-row>
    </v-overlay>
</template>
<script>
import overlaySettingCommission from "./overlay-setting-commission.vue";
import OverlaySettingHoliday from "./overlay-setting-holiday.vue";

export default {
    components: { overlaySettingCommission, OverlaySettingHoliday },
    data() {
        return { show: false };
    },
    methods: {
        open() {
            this.show = true;
        },
        close() {
            this.show = false;
        },
    },
};
</script>
